import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const bonusBooks = [{
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3G7SzG2ahym4Aez18FTYxn/b2_portada_kit_emocional.png',
  title: 'Kit de Emergencia Emocional',
  subtitle: 'Respuestas para el caos diario'
}, {
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wVfRFii2mWtAghxpV7JNMh/b3portada_el_poder_del_no.png',
  title: 'El Poder del No',
  subtitle: 'Cómo poner límites en familia y trabajo'
}, {
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/db4LrxyxxvLdrsasbi9Sfj/b4_portada_adios_carga_mental.png',
  title: 'Adiós Carga Mental',
  subtitle: 'El plan simple para reducir tu estrés mental'
}, {
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3eyJEogzStRr6ptQJhP6YB/b5_portada_dialogo_interno.png',
  title: 'Diálogo Interno',
  subtitle: 'Reprograma tu voz interna'
}, {
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xbkXSF2EBnEPMJSwpWdTYm/b6_portada_rutinas_expres.png',
  title: 'Rutinas Exprés para Mamás',
  subtitle: 'Rutinas para recargar energía'
}];
export function BonusCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      handleNext();
    }, 5000);
    return () => clearInterval(timer);
  }, [currentIndex]);
  const handleNext = () => {
    setDirection(1);
    setCurrentIndex(prev => (prev + 1) % bonusBooks.length);
  };
  const handlePrev = () => {
    setDirection(-1);
    setCurrentIndex(prev => (prev - 1 + bonusBooks.length) % bonusBooks.length);
  };
  const handleDotClick = (index: number) => {
    setDirection(index > currentIndex ? 1 : -1);
    setCurrentIndex(index);
  };
  const slideVariants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 300 : -300,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      x: direction > 0 ? -300 : 300,
      opacity: 0
    })
  };
  return <div className="relative w-full md:hidden" data-id="element-1">
      {/* Carousel Container */}
      <div className="relative overflow-hidden rounded-3xl shadow-2xl bg-gradient-to-br from-amber-50 to-stone-100" data-id="element-2">
        <div className="relative w-full" style={{
        paddingBottom: '140%'
      }} data-id="element-3">
          <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-4">
            <motion.div key={currentIndex} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
            x: {
              type: 'spring',
              stiffness: 300,
              damping: 30
            },
            opacity: {
              duration: 0.3
            }
          }} className="absolute inset-0 flex flex-col items-center justify-center p-6" data-id="element-5">
              {/* Book Cover Image */}
              <div className="w-full h-4/5 flex items-center justify-center mb-4" data-id="element-6">
                <img src={bonusBooks[currentIndex].image} alt={bonusBooks[currentIndex].title} className="w-full h-full object-contain" data-id="element-7" />
              </div>

              {/* Book Info */}
              <div className="text-center" data-id="element-8">
                <h3 className="text-xl font-serif text-text-main mb-2" data-id="element-9">
                  {bonusBooks[currentIndex].title}
                </h3>
                <p className="text-sm text-primary font-semibold" data-id="element-10">
                  {bonusBooks[currentIndex].subtitle}
                </p>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Navigation Arrows */}
        <motion.button onClick={handlePrev} whileHover={{
        scale: 1.1,
        x: -4
      }} whileTap={{
        scale: 0.9
      }} className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/95 hover:bg-white rounded-full shadow-xl flex items-center justify-center text-text-main transition-colors z-10" aria-label="Bono anterior" data-id="element-11">
          <ChevronLeft className="w-5 h-5" data-id="element-12" />
        </motion.button>

        <motion.button onClick={handleNext} whileHover={{
        scale: 1.1,
        x: 4
      }} whileTap={{
        scale: 0.9
      }} className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/95 hover:bg-white rounded-full shadow-xl flex items-center justify-center text-text-main transition-colors z-10" aria-label="Siguiente bono" data-id="element-13">
          <ChevronRight className="w-5 h-5" data-id="element-14" />
        </motion.button>
      </div>

      {/* Progress Dots */}
      <div className="flex justify-center gap-2 mt-6" data-id="element-15">
        {bonusBooks.map((_, index) => <motion.button key={index} onClick={() => handleDotClick(index)} whileHover={{
        scale: 1.2
      }} whileTap={{
        scale: 0.9
      }} className={`rounded-full transition-all ${index === currentIndex ? 'w-8 h-2 bg-primary' : 'w-2 h-2 bg-gray-300'}`} aria-label={`Ver bono ${index + 1}`} data-id="element-16" />)}
      </div>
    </div>;
}